import React from 'react';
import styled from 'styled-components';
import { FaSun, FaMoon } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <ToggleButton 
      onClick={toggleTheme}
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.95 }}
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? <FaSun /> : <FaMoon />}
    </ToggleButton>
  );
};

const ToggleButton = styled(motion.button)`
  background: transparent;
  border: 1px solid var(--accent);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent);
  cursor: pointer;
  transition: var(--transition);
  padding: 0;
  
  &:hover {
    background-color: rgba(100, 255, 218, 0.1);
  }

  svg {
    font-size: 18px;
  }
`;

export default ThemeToggle;